import Iconify from '@emfood/shared/src/components/iconify';

import { Box, Tooltip, IconButton } from '@mui/material';

interface Props {
  isDisabled?: boolean;
  isLoading?: boolean;
  onClick: () => void;
  quantity?: number;
  maxQuantity?: number;
}

export default function AddToCartButton({
  isDisabled,
  isLoading,
  onClick,
  quantity,
  maxQuantity,
}: Props) {
  const insufficientStock = !!quantity && !!maxQuantity && quantity > maxQuantity;
  const disabled = isDisabled || insufficientStock || isLoading;
  const tooltipTitle = insufficientStock
    ? `Quantity must be ${maxQuantity} or less`
    : 'Add to basket';

  const icon = isLoading
    ? 'eos-icons:loading'
    : insufficientStock
      ? 'solar:danger-triangle-bold'
      : 'solar:cart-plus-bold';

  return (
    <Tooltip title={tooltipTitle}>
      {/* Box span keeps the tooltip working when the IconButton is disabled. */}
      <Box component="span">
        <IconButton onClick={onClick} disabled={disabled} aria-label="Add to basket">
          <Iconify icon={icon} />
        </IconButton>
      </Box>
    </Tooltip>
  );
}
